var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }, [_c("w-spacer")], 1),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                [
                  _c("app-sale-layout-list", {
                    attrs: {
                      printers: _vm.printers,
                      title: _vm.clientsTitle,
                      layouts: _vm.clientLayouts,
                      "contact-group-id": 1,
                      order: _vm.userConf.SaleLayoutDisplayOrder,
                    },
                    on: {
                      order: function ($event) {
                        return _vm.saveSaleOrder($event)
                      },
                      copy: function ($event) {
                        return _vm.copyLayout($event)
                      },
                      delete: function ($event) {
                        return _vm.deleteLayout($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                [
                  _c("app-sale-layout-list", {
                    attrs: {
                      printers: _vm.printers,
                      title: _vm.suppliersTitle,
                      layouts: _vm.supplierLayouts,
                      "contact-group-id": 2,
                      order: _vm.userConf.PurchaseLayoutDisplayOrder,
                    },
                    on: {
                      copy: function ($event) {
                        return _vm.copyLayout($event)
                      },
                      delete: function ($event) {
                        return _vm.deleteLayout($event)
                      },
                      order: function ($event) {
                        return _vm.savePurchaseOrder($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.missingModule,
            callback: function ($$v) {
              _vm.missingModule = $$v
            },
            expression: "missingModule",
          },
        },
        [
          _c("app-missing-module-modal", {
            attrs: { "module-id": 13 },
            on: {
              close: function ($event) {
                _vm.missingModule = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }